/** Default Scholar Dollar payroll settings (v1). Tax rate is also snapshotted per import/row. */
export const PAYROLL_CONFIG = {
  taxRate: 0.1,
  dollarsPerPercentagePoint: 1,
  maxPeriods: 8,
  skipZeroGross: true,
  /** Tax Day reporting and YTD withholding export is active. */
  enableTaxDayExport: true,
  /** Primary school domain for roster email generation. */
  rosterEmailDomain: 'scholar.dpacnevada.org',
  paycheckTransactionTypeName: 'Scholar Dollar Paycheck',
} as const;

export type PayrollConfig = typeof PAYROLL_CONFIG;
